<form>
  <div ngbDropdown class="d-flex filter-by" [autoClose]="true" role="group" *ngIf="filterOptions">
    <button id="dropdownMenuButton" class="tool-bar__option btn dropdown-toggle w-100" type="button" ngbDropdownToggle>
      <span class="svg filter my-0" [inlineSVG]="'assets/images/icons/filter.svg'"></span>
      <label class="font-size-14 mb-0">Filter</label>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownMenuButton" class="col-12 shadow dropdown-menu-end filter-dropdown mt-2">
      <div class="d-flex flex-column">
        <button
          type="button"
          class="filter-bar-item filter-item text-black bg-white py-0 font-size-12 rounded"
          role="radio"
          [attr.aria-checked]="selectedOption == undefined"
          (click)="resetFilter()"
        >
          <div class="w-100 h-100">
            <div class="radio-item d-flex align-items-center px-2">
              <input
                type="radio"
                name="filterBy"
                id="undefinedOption"
                value="undefined"
                class="me-3"
                [checked]="selectedOption == undefined"
              />
              <label
                for="undefinedOption"
                class="mb-0 font-size-14"
                [ngClass]="selectedOption == undefined ? 'text-primary fw-bold' : 'fw-normal'"
                >All</label
              >
            </div>
          </div>
        </button>
        <button
          type="button"
          *ngFor="let option of filterOptions.options"
          role="radio"
          [attr.aria-checked]="selectedOption == option"
          (click)="filterByProperty(option)"
          class="filter-bar-item filter-item text-black bg-white py-0 font-size-12 rounded"
        >
          <div class="w-100 h-100">
            <div class="radio-item d-flex align-items-center px-2">
              <input
                type="radio"
                name="filterBy"
                id="{{ option }}"
                value="{{ option }}"
                class="me-3"
                [checked]="selectedOption == option"
              />
              <label
                for="{{ option }}"
                class="mb-0 font-size-14"
                [ngClass]="selectedOption == option ? 'text-primary fw-bold' : 'fw-normal'"
                >{{ option }}</label
              >
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</form>
